/**
 * LocalStorage
 */
export class LocalStorage {
  private contentKey: string;
  private updatedAtKey: string;

  /**
   * constructor
   * @param  {string} link
   * @return {LocalStorage}
   */
  public constructor(link: string) {
    this.contentKey   = `codepad_ls_content_${link}`;
    this.updatedAtKey = `codepad_ls_updated_at_${link}`;
  }

  /**
   * getUpdatedAt
   * @return {number}
   */
  public getUpdatedAt = (): number => {
    const value = localStorage.getItem(this.updatedAtKey);
    const date = Date.parse(value);
    return !value || isNaN(date) ? 0 : date;
  }

  /**
   * getContent
   * @return {string}
   */
  public getContent = (): string => {
    return localStorage.getItem(this.contentKey);
  }

  /**
   * update
   * @param  {string} content
   * @param  {boolean} undateDate
   * @return undefined
   */
  public update = (content, updateDate?: boolean): void => {
    this.setContent(content);
    updateDate && this.setUpdatedAt();
  }

  /**
   * setContent
   * @param  {string} content
   * @return undefined
   */
  private setContent = (content: string): void => {
    localStorage.setItem(this.contentKey, content);
  }

  /**
   * setUpdatedAt
   * @return undefined
   */
  private setUpdatedAt = (): void => {
    localStorage.setItem(this.updatedAtKey, new Date().toISOString());
  }
}
